import ConnexionForm from './ConnexionForm.view';

export default ConnexionForm;
